import axios, { AxiosHeaders, InternalAxiosRequestConfig } from "axios";
import { resolveEndpoint } from "./utils";

export const api = axios.create({
  baseURL: resolveEndpoint()
});

api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Optional: skip auth for /auth endpoints
    if (config.url?.startsWith("/auth")) return config;

    const token = localStorage.getItem("token");
    if (token) {
      const h = config.headers as
        | AxiosHeaders
        | Record<string, any>
        | undefined;
      if (h && typeof (h as AxiosHeaders).set === "function") {
        (h as AxiosHeaders).set("authorization", `Bearer ${token}`);
      } else {
        config.headers.set("authorization", `Bearer ${token}`);
      }
    } else if (config.headers) {
      // ensure no stale header
      if (typeof (config.headers as any).delete === "function") {
        (config.headers as AxiosHeaders).delete("authorization");
      } else {
        delete (config.headers as any).authorization;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);